// extracted by mini-css-extract-plugin
export default {"container":"Rooms_container__Pxyds","carousel":"Rooms_carousel__uR6xP","card":"Rooms_card__jhJyD","info":"Rooms_info__aGatB","icons":"Rooms_icons__wZMdU"};